module.exports = __webpack_public_path__ + "static/media/features-banner-img.9536812b.png";